// import crypto from 'crypto';
import validator from 'validator';
import { useEffect } from 'react';

/**
 * Set a cookie
 */
export const setCookie = (name, value, expirationDays = 30) => {
    const d = new Date();
    d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`;
};

/**
 * // TODO: modernize
 * Get a cookie name and value
 * @param {String} name - name of the cookie
 */
export const getCookie = name => {
    const _name = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(_name) === 0) {
            return c.substring(_name.length, c.length);
        }
    }
    return '';
};

/**
 * Verify that a string is a valid URL
 * @param {String} url
 */
export const isValidURL = url => {
    return validator.isURL(url);
};

const isValidWebsite = url => {
    const regex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z]{2,63})+)(\/[^\s]*)?$/;
    return regex.test(url);
};

export const getCorrectedUrl = url => {
    if (url && typeof url === 'string' && isValidWebsite(url)) {
        if (!url.includes('http://') && !url.includes('https://')) {
            return `https://${url}`;
        } else {
            return url;
        }
    }
    return '';
};

/**
 * Perform a sha1 encryption on a string
 * @param {String} str - string to be encrypted
 * @return {string} encrypted value of the string
 */
// export const sha1 = async str => {
//     // native browser option
//     console.log('SHA-1', str);
//     return await window.crypto.subtle.digest('SHA-1', new TextEncoder().encode(pin));
// };

// crypto
//     .createHash('sha1')
//     .update(str, 'utf8')
//     .digest('hex');

const MAX_32_BIT_INTEGER = 2147483647;

export const refresh = () => window.location.reload(true);

/**
 * Set functions to run at a specific time
 * @param {Date} time - a time to trigger functions (`fns`)
 * @param {Function[]} fns - functions to schedule
 */
export const scheduleAtTime = (time, fns) => {
    const offsetMillis = new Date(time).getTime() - new Date().getTime();
    if (offsetMillis > 0 && offsetMillis < MAX_32_BIT_INTEGER) {
        fns.forEach(fn => setTimeout(fn, offsetMillis));
    }
};

export const hexToRGBA = (hex, opacity) => {
    let r = 0,
        g = 0,
        b = 0;

    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const useHashFragment = (offset = 0, trigger = true) => {
    useEffect(() => {
        const scrollToHashElement = () => {
            const { hash } = window.location;
            const elementToScroll = document.getElementById(hash?.replace('#', ''));

            if (!elementToScroll) return;

            window.scrollTo({
                top: elementToScroll.offsetTop - offset,
                behavior: 'smooth',
            });
        };

        if (!trigger) return;
        setTimeout(scrollToHashElement, 100);
        window.addEventListener('hashchange', scrollToHashElement);
        return () => window.removeEventListener('hashchange', scrollToHashElement);
    }, [trigger]);
};

export const capitalize = str => str?.trim()?.toUpperCase() || '';
